import { observer } from "mobx-react";
import * as React from "react";
import { useContext } from "react";
import { runInAction } from "mobx";
import { costString } from "../../../config/Registration";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { RootStoreContext } from "../../../stores/RootStore";
import CancelCheckinPopup from "./CancelCheckinPopup";
import './styles.css';
import venueBadge from "./venueBadge";

const SellingItemOption = observer(({ item }) => {
  const { registrationStore } = useContext(RootStoreContext);
  const [showLevelPopup, setShowLevelPopup] = React.useState(false);
  const [showCancelPopup, setShowCancelPopup] = React.useState(false);

  const onSelect = () => {
    if (!item.isCheckedIn && item.levelSufficient !== false) {
      runInAction(() => (item.selected = !item.selected));
    }
  };

  const onInfoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowLevelPopup(true);
  };

  const closeLevelPopup = () => {
    setShowLevelPopup(false);
  };

  const isLocked = item.levelSufficient === false;

  const renderCost = () => {
    if (item.discountedSessionCost !== null && item.discountedSessionCost !== undefined) {
      return (
        <>
          <span style={{ textDecoration: 'line-through', marginRight: '8px' }}>
            {costString(item.cost)}
          </span>
          <span className="discounted-cost">
            {costString(item.discountedSessionCost)}
          </span>
        </>
      );
    }
    return costString(item.cost);
  };

  return (
    <>
      <div className="item-container">
        <div
          className={`venue-option ticket-option ${item.selected ? "active" : ""} ${item.isCheckedIn ? "checked-in" : ""} ${isLocked ? "locked" : ""}`}
          onClick={onSelect}
        >
          <div className="venue-details">
            {venueBadge(item)}
            <div className="venue-name">
              {item.time && <span className="time-tag">{item.time.timeString}</span>}
              {item.nameString}
            </div>
            <div className="venue-address">
              <span className="item-description">
                {!item.isCheckedIn ? renderCost() : null}
                {item.description && ` ${item.description}`}
              </span>
            </div>
          </div>
          {isLocked && (
              <FontAwesomeIcon icon={faInfoCircle} className="locked-info-icon" onClick={onInfoClick} />
          )}
          {!item.isCheckedIn && !isLocked && (
            <div className="ticket-checkbox">
              <input
                type="checkbox"
                checked={item.selected}
                readOnly
                className="ticket-check"
              />
            </div>
          )}
          {item.isCheckedIn && item.canCancel && (
            <a
              href="#"
              className="cancel-checkin-link"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowCancelPopup(true);
              }}
            >
              Cancel
            </a>
          )}
        </div>
      </div>

      {showCancelPopup && (
        <CancelCheckinPopup
          item={item}
          onClose={() => setShowCancelPopup(false)}
          onSuccess={async () => {
            try {
              await registrationStore.refreshUser();
            } catch (error) {
              console.error('Failed to refresh user booking history:', error);
            } finally {
              await registrationStore.loadSellingItems(registrationStore.selectedDate, true);
            }
          }}
        />
      )}

      {showLevelPopup && (
        <div className="level-popup-overlay" onClick={closeLevelPopup}>
          <div className="level-popup" onClick={e => e.stopPropagation()}>
            <div className="level-popup-content">
              <h3>Level Requirement</h3>
              <p>
                You currently don't have the minimum required level for this class assigned in our system.
                Please discuss with your teachers how to progress to the higher levels.
              </p>
            </div>
            <button className="level-popup-close" onClick={closeLevelPopup}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
});

export default SellingItemOption;
